const INTERLAY_COMPANY_LINK = 'https://www.interlay.io';
const INTERLAY_EMAIL_LINK = 'mailto:contact@interlay.io';
const INTERLAY_DISCORD_LINK = 'https://discord.gg/KgCYK3MKSf';
const INTERLAY_GITHUB_LINK = 'https://github.com/interlay';
const INTERLAY_TWITTER_LINK = 'https://twitter.com/interlayHQ';
const INTERLAY_DOCS_LINK = 'https://docs.interlay.io';
const INTERLAY_CROWDLOAN_LINK = 'https://crowdloan.interlay.io';
const KINTSUGI_CROWDLOAN_LINK = 'https://claim-kint.interlay.io';
const INTERLAY_TERMS_AND_CONDITIONS_LINK =
  'https://drive.google.com/file/d/1_oA3ZHoqzIFcE7Z-YeNTJ8g3bpeB9Glt/view?usp=sharing';
const KINTSUGI_TERMS_AND_CONDITIONS_LINK =
  'https://drive.google.com/file/d/1TuTu49EoTdEoZX8LrysdgbDmuHS0uAvr/view?usp=sharing ';
const INTERLAY_USE_WRAPPED_CURRENCY_LINK = 'https://docs.interlay.io/#/interlay/earn-with-ibtc';
const KINTSUGI_USE_WRAPPED_CURRENCY_LINK = 'https://docs.interlay.io/#/kintsugi/Earn-With-kBTC';
const INTERLAY_GOVERNANCE_LINK = 'https://interlay.subsquare.io/';
const KINTSUGI_GOVERNANCE_LINK = 'https://kintsugi.subsquare.io';
const INTERLAY_SUBSCAN_LINK = 'https://interlay.subscan.io';
const KINTSUGI_SUBSCAN_LINK = 'https://kintsugi.subscan.io';
const INTERLAY_VAULT_DOCS_LINK = 'https://docs.interlay.io/#/vault/overview';
const INTERLAY_DOS_AND_DONTS_DOCS_LINK = 'https://docs.interlay.io/#/vault/installation?id=dos-and-donts';

export {
  INTERLAY_COMPANY_LINK,
  INTERLAY_CROWDLOAN_LINK,
  INTERLAY_DISCORD_LINK,
  INTERLAY_DOCS_LINK,
  INTERLAY_DOS_AND_DONTS_DOCS_LINK,
  INTERLAY_EMAIL_LINK,
  INTERLAY_GITHUB_LINK,
  INTERLAY_GOVERNANCE_LINK,
  INTERLAY_SUBSCAN_LINK,
  INTERLAY_TERMS_AND_CONDITIONS_LINK,
  INTERLAY_TWITTER_LINK,
  INTERLAY_USE_WRAPPED_CURRENCY_LINK,
  INTERLAY_VAULT_DOCS_LINK,
  KINTSUGI_CROWDLOAN_LINK,
  KINTSUGI_GOVERNANCE_LINK,
  KINTSUGI_SUBSCAN_LINK,
  KINTSUGI_TERMS_AND_CONDITIONS_LINK,
  KINTSUGI_USE_WRAPPED_CURRENCY_LINK
};
